import React from 'react'


const EmptyStateLogoOption2 = () => {
  return (
    <svg
      width='200'
      height='146'
      viewBox='0 0 200 146'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_4500_30926)'>
        <path
          d='M57.5453 16C51.4128 16 46.4492 20.9618 46.4492 27.0921V117.997C46.4492 124.127 51.4128 129.089 57.5453 129.089H88.9362V16H57.5453Z'
          fill='white'
        />
        <path
          d='M120.328 16H88.9375V129.089H120.328C126.461 129.089 131.424 124.127 131.424 117.997V27.0921C131.424 20.9618 126.461 16 120.328 16Z'
          fill='white'
        />
      </g>
      <path
        d='M46.5508 119.419C47.2453 124.872 51.904 129.089 57.5452 129.089H120.327C125.968 129.089 130.627 124.872 131.321 119.419H46.5508Z'
        fill='white'
      />
      <g filter='url(#filter1_d_4500_30926)'>
        <path
          d='M97.2387 16H43.9944C38.3532 16 33.6946 20.2167 33 25.6696H109.317C110.012 20.2167 114.671 16 120.312 16H97.2387Z'
          fill='#C3B9A2'
        />
      </g>
      <path
        d='M80.1473 129.089H133.392C139.033 129.089 143.691 124.872 144.386 119.419H68.0687C67.3741 124.872 62.7154 129.089 57.0742 129.089H80.1473Z'
        fill='#C3B9A2'
      />
      <path
        d='M73.8268 95.7957C69.9135 93.5264 64.8991 94.8643 62.6291 98.7761C60.359 102.688 61.6973 107.701 65.6106 109.97C69.5239 112.239 74.5383 110.901 76.8083 106.989C79.0784 103.078 77.7401 98.0649 73.8268 95.7957Z'
        fill='#B39246'
      />
      <path
        d='M59.8515 95.9986C63.3921 90.9182 70.3039 89.3095 75.7587 92.4762C78.8928 94.2882 80.8748 97.3026 81.5185 100.588L83.1279 100.927C82.5519 96.9808 80.248 93.306 76.5211 91.1553C70.1853 87.4805 62.1216 89.5127 58.2422 95.6769L59.8515 96.0155V95.9986Z'
        fill='#B39246'
      />
      <path
        d='M79.5693 109.749C76.0287 114.83 69.117 116.439 63.6621 113.272C60.5281 111.46 58.5461 108.446 57.9023 105.16L56.293 104.822C56.8689 108.767 59.1729 112.425 62.8998 114.593C69.2356 118.268 77.2993 116.235 81.1787 110.071L79.5693 109.733V109.749Z'
        fill='#B39246'
      />
      <path
        d='M53.7494 96.1494L52.3906 102.578L85.6726 109.607L87.0313 103.179L53.7494 96.1494Z'
        fill='#B39246'
      />
      <path
        d='M57.2075 98.0303L58.3087 98.2674L58.7491 102.772L57.7666 102.569L57.6649 101.671L56.3944 101.4L55.937 102.196L54.9375 101.993L57.2075 98.0641V98.0303ZM57.6311 100.791L57.5125 99.3681L56.784 100.621L57.6141 100.791H57.6311Z'
        fill='white'
      />
      <path
        d='M59.9682 98.623L61.8147 99.0125C62.3737 99.1311 63.0175 99.4359 62.7634 100.604C62.4923 101.925 61.7469 101.874 61.2387 101.739C61.0185 101.671 60.3917 101.451 60.3578 101.434L60.019 103.043L59.0703 102.84L59.9682 98.623ZM61.3234 100.892C61.5606 100.943 61.713 100.825 61.8147 100.418C61.8994 100.012 61.7639 99.8593 61.5606 99.8254L60.7474 99.6561L60.5272 100.74L61.3403 100.909L61.3234 100.892Z'
        fill='white'
      />
      <path
        d='M63.4916 99.3516L65.3381 99.7411C65.8972 99.8596 66.5409 100.164 66.2868 101.333C66.0157 102.654 65.2704 102.603 64.7621 102.468C64.5419 102.4 63.9151 102.18 63.8812 102.163L63.5424 103.771L62.5938 103.568L63.4916 99.3516ZM64.8468 101.638C65.084 101.689 65.2365 101.57 65.3381 101.164C65.4228 100.757 65.2873 100.605 65.084 100.571L64.2709 100.402L64.0506 101.485L64.8638 101.655L64.8468 101.638Z'
        fill='white'
      />
      <path
        d='M67.0176 100.097L68.8811 100.486C69.5757 100.639 70.0331 101.045 69.8128 102.078C69.5926 103.111 69.186 103.162 68.898 103.196L69.3215 104.991L68.2543 104.771L67.9494 103.094L67.4242 102.891L67.0854 104.517L66.1367 104.313L67.0346 100.097H67.0176ZM68.3729 102.332C68.6609 102.4 68.7625 102.298 68.8472 101.875C68.9319 101.502 68.8472 101.333 68.5931 101.282L67.78 101.113L67.5597 102.146L68.3729 102.315V102.332Z'
        fill='white'
      />
      <path
        d='M72.1329 101.146C73.1324 101.349 73.81 101.705 73.3865 103.669C72.9969 105.532 72.2684 105.634 71.2181 105.413C70.1847 105.193 69.541 104.871 69.9475 102.941C70.3711 100.96 71.1503 100.926 72.1159 101.146H72.1329ZM71.4214 104.567C72.0143 104.685 72.2345 104.516 72.4548 103.483C72.7089 102.314 72.5564 102.145 71.9635 102.01C71.3875 101.891 71.1673 101.942 70.9132 103.161C70.6929 104.194 70.7776 104.431 71.4214 104.567Z'
        fill='white'
      />
      <path
        d='M74.9956 101.789L75.1819 104.99L76.7066 102.162L77.7061 102.365L75.4869 106.294L74.3688 106.057L73.9961 101.569L74.9956 101.773V101.789Z'
        fill='white'
      />
      <path
        d='M77.6735 103.314C77.8429 102.518 78.4528 102.518 78.8593 102.603C78.8593 102.603 80.2146 102.908 80.7058 103.094L80.5364 103.873L78.9271 103.534C78.6222 103.467 78.5883 103.636 78.5544 103.788L78.4528 104.263L80.079 104.669L79.9096 105.448L78.2664 105.16L78.1648 105.634C78.097 105.939 78.2833 105.973 78.4528 106.007L80.0113 106.329L79.8419 107.108C79.3845 107.074 78.0123 106.82 78.0123 106.82C77.6396 106.752 76.9789 106.532 77.1653 105.702L77.6735 103.28V103.314Z'
        fill='white'
      />
      <path
        d='M81.1596 103.094L83.04 103.483C84.2258 103.737 84.2766 104.804 84.0395 105.922C83.7515 107.26 83.1416 107.92 82.1421 107.7L80.2617 107.31L81.1596 103.094ZM82.2268 106.87C82.6673 106.955 82.9214 106.548 83.0908 105.719C83.328 104.635 83.1416 104.364 82.7689 104.296L81.9219 104.11L81.3798 106.684L82.2268 106.87Z'
        fill='white'
      />
      <path
        d='M124.258 56.4902H53.793V61.1177H124.258V56.4902Z'
        fill='#E2DAC9'
      />
      <path
        d='M124.258 46.0781H53.793V50.7056H124.258V46.0781Z'
        fill='#E2DAC9'
      />
      <path
        d='M124.258 66.9023H53.793V71.5298H124.258V66.9023Z'
        fill='#E2DAC9'
      />
      <path
        d='M154.886 127.819H96.3906V78.2176L125.545 53.5439L154.886 78.2176V127.819Z'
        fill='#E6D0C5'
      />
      <path
        d='M125.547 53.5439L92.9531 82.1125V127.819H125.648V53.6117L125.547 53.5439Z'
        fill='#F5E4BE'
      />
      <path
        d='M158.327 83.0954L125.648 53.6123V127.82H158.327V83.0954Z'
        fill='#F2D082'
      />
      <path
        d='M152.179 52.6475V72.9012L146.707 63.7565V52.6475H152.179Z'
        fill='#444C8C'
      />
      <path
        d='M146.706 52.6475H141.234V63.7565H146.706V52.6475Z'
        fill='#444C8C'
      />
      <path
        d='M145.453 54.1885H141.234V56.39H145.453V54.1885Z'
        fill='#989BB5'
      />
      <path
        d='M152.179 56.7959H147.961V58.9974H152.179V56.7959Z'
        fill='#989BB5'
      />
      <path
        d='M145.539 60.0137H141.32V62.2152H145.539V60.0137Z'
        fill='#989BB5'
      />
      <path
        d='M146.708 47.5498H139.305V52.7826H146.708V47.5498Z'
        fill='#989BB5'
      />
      <path
        d='M154.11 47.5498H146.707V52.7826H154.11V47.5498Z'
        fill='#989BB5'
      />
      <path
        d='M146.708 47.5498H139.305V48.4812H146.708V47.5498Z'
        fill='#444C8C'
      />
      <path
        d='M154.11 47.5498H146.707V48.4812H154.11V47.5498Z'
        fill='#444C8C'
      />
      <path
        d='M152.179 63.9424H147.961V66.1439H152.179V63.9424Z'
        fill='#989BB5'
      />
      <path
        d='M125.631 73.3574H119.262V91.0371H125.631V73.3574Z'
        fill='#F8F9FC'
      />
      <path
        d='M132.002 73.3574H125.633V91.0371H132.002V73.3574Z'
        fill='#F8F9FC'
      />
      <path
        d='M125.63 74.7803H120.684V89.6149H125.63V74.7803Z'
        fill='#2D4375'
      />
      <path
        d='M130.576 74.7803H125.629V89.6149H130.576V74.7803Z'
        fill='#1E2D4F'
      />
      <path
        d='M119.278 73.3574H113.637V91.0371H119.278V73.3574Z'
        fill='#989BB5'
      />
      <path
        d='M137.657 73.3574H132.016V91.0371H137.657V73.3574Z'
        fill='#989BB5'
      />
      <path
        d='M118.769 75.0508H114.145V76.1515H118.769V75.0508Z'
        fill='#444C8C'
      />
      <path
        d='M137.168 75.0508H132.543V76.1515H137.168V75.0508Z'
        fill='#444C8C'
      />
      <path
        d='M118.769 78.3359H114.145V79.4367H118.769V78.3359Z'
        fill='#444C8C'
      />
      <path
        d='M137.168 78.3359H132.543V79.4367H137.168V78.3359Z'
        fill='#444C8C'
      />
      <path
        d='M118.769 81.6387H114.145V82.7394H118.769V81.6387Z'
        fill='#444C8C'
      />
      <path
        d='M137.168 81.6387H132.543V82.7394H137.168V81.6387Z'
        fill='#444C8C'
      />
      <path
        d='M118.769 84.9238H114.145V86.0246H118.769V84.9238Z'
        fill='#444C8C'
      />
      <path
        d='M137.168 84.9238H132.543V86.0246H137.168V84.9238Z'
        fill='#444C8C'
      />
      <path
        d='M118.769 88.209H114.145V89.3097H118.769V88.209Z'
        fill='#444C8C'
      />
      <path
        d='M137.168 88.209H132.543V89.3097H137.168V88.209Z'
        fill='#444C8C'
      />
      <path
        d='M161.325 127.819H89.9375V134.017H161.325V127.819Z'
        fill='#2D4375'
      />
      <path
        d='M126.885 56.6775V48.3457L89.9375 83.2309L92.9529 86.9057V88.5653L126.885 56.6775Z'
        fill='#DBD0B3'
      />
      <path
        d='M125.651 56.1013V47.7695L88.7031 82.6547L92.9552 86.9053L125.651 56.1013Z'
        fill='white'
      />
      <path
        d='M125.648 47.7695V56.1013L158.327 86.9053L162.613 82.6209L125.648 47.7695Z'
        fill='white'
      />
      <path
        d='M125.632 43.0449L84.2969 82.0791L89.0572 86.8377L125.632 52.3759V43.0449Z'
        fill='#2D4375'
      />
      <path
        d='M125.633 43.0449V52.3759L162.224 86.8377L167.002 82.0452L125.633 43.0449Z'
        fill='#1E2D4F'
      />
      <path d='M125.649 97.71H111.758V123.518H125.649V97.71Z' fill='#F8F9FC' />
      <path d='M139.524 97.71H125.633V123.518H139.524V97.71Z' fill='#F8F9FC' />
      <path
        d='M137.576 99.793H125.633V121.435H137.576V99.793Z'
        fill='#1E2D4F'
      />
      <path
        d='M125.633 99.793H113.707V121.435H125.633V99.793Z'
        fill='#2D4375'
      />
      <path d='M111.757 97.71H104.016V123.518H111.757V97.71Z' fill='#989BB5' />
      <path d='M147.25 97.71H139.508V123.518H147.25V97.71Z' fill='#989BB5' />
      <path
        d='M111.079 100.183H104.727V101.791H111.079V100.183Z'
        fill='#444C8C'
      />
      <path
        d='M146.571 100.183H140.219V101.791H146.571V100.183Z'
        fill='#444C8C'
      />
      <path
        d='M111.079 104.992H104.727V106.601H111.079V104.992Z'
        fill='#444C8C'
      />
      <path
        d='M146.571 104.992H140.219V106.601H146.571V104.992Z'
        fill='#444C8C'
      />
      <path
        d='M111.079 109.784H104.727V111.393H111.079V109.784Z'
        fill='#444C8C'
      />
      <path
        d='M146.571 109.784H140.219V111.393H146.571V109.784Z'
        fill='#444C8C'
      />
      <path
        d='M111.079 114.594H104.727V116.203H111.079V114.594Z'
        fill='#444C8C'
      />
      <path
        d='M146.571 114.594H140.219V116.203H146.571V114.594Z'
        fill='#444C8C'
      />
      <path
        d='M111.079 119.386H104.727V120.995H111.079V119.386Z'
        fill='#444C8C'
      />
      <path
        d='M146.571 119.386H140.219V120.995H146.571V119.386Z'
        fill='#444C8C'
      />
      <path
        d='M138.472 108.243H112.824V110.021H138.472V108.243Z'
        fill='#F8F9FC'
      />
      <path
        d='M126.478 98.6582H124.801V109.801H126.478V98.6582Z'
        fill='#F8F9FC'
      />
      <path
        d='M79.4202 38.168V32.7505H80.5656V37.2236H82.8881V38.168H79.4202ZM88.414 35.4592C88.414 36.05 88.302 36.5526 88.078 36.967C87.8558 37.3815 87.5525 37.698 87.1681 37.9167C86.7854 38.1336 86.3551 38.242 85.8772 38.242C85.3958 38.242 84.9637 38.1327 84.581 37.914C84.1984 37.6954 83.8959 37.3788 83.6737 36.9644C83.4515 36.55 83.3404 36.0483 83.3404 35.4592C83.3404 34.8685 83.4515 34.3659 83.6737 33.9515C83.8959 33.537 84.1984 33.2214 84.581 33.0045C84.9637 32.7858 85.3958 32.6765 85.8772 32.6765C86.3551 32.6765 86.7854 32.7858 87.1681 33.0045C87.5525 33.2214 87.8558 33.537 88.078 33.9515C88.302 34.3659 88.414 34.8685 88.414 35.4592ZM87.2527 35.4592C87.2527 35.0766 87.1954 34.7539 87.0808 34.4911C86.9679 34.2283 86.8083 34.0291 86.602 33.8933C86.3957 33.7575 86.1541 33.6896 85.8772 33.6896C85.6003 33.6896 85.3587 33.7575 85.1524 33.8933C84.9461 34.0291 84.7856 34.2283 84.671 34.4911C84.5581 34.7539 84.5017 35.0766 84.5017 35.4592C84.5017 35.8419 84.5581 36.1646 84.671 36.4274C84.7856 36.6902 84.9461 36.8894 85.1524 37.0252C85.3587 37.161 85.6003 37.2289 85.8772 37.2289C86.1541 37.2289 86.3957 37.161 86.602 37.0252C86.8083 36.8894 86.9679 36.6902 87.0808 36.4274C87.1954 36.1646 87.2527 35.8419 87.2527 35.4592ZM89.8907 38.168H88.6633L90.5335 32.7505H92.0095L93.877 38.168H92.6497L91.2926 33.9885H91.2503L89.8907 38.168ZM89.814 36.0386H92.7131V36.9326H89.814V36.0386ZM99.0604 32.7505V38.168H98.0711L95.7142 34.7583H95.6745V38.168H94.5291V32.7505H95.5343L97.8727 36.1576H97.9203V32.7505H99.0604Z'
        fill='#444C8C'
      />
      <defs>
        <filter
          id='filter0_d_4500_30926'
          x='38.4492'
          y='12'
          width='100.975'
          height='129.089'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='4' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4500_30926'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_4500_30926'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_d_4500_30926'
          x='27'
          y='11'
          width='103.312'
          height='25.6697'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='2' dy='3' />
          <feGaussianBlur stdDeviation='4' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.865516 0 0 0 0 0.841296 0 0 0 0 0.785105 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4500_30926'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_4500_30926'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
};
export { EmptyStateLogoOption2 };